import { RadioSwatchGroup_MoreButton_default } from "./chunk-UQJQUVJV.js";
import { CheckableGroupComponent } from "./chunk-AUZ3GMLH.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioSwatchGroup/RadioSwatchGroup.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioSwatchGroup = _a => {
  var _b = _a,
    {
      children,
      maxItems = 8,
      moreButton = /* @__PURE__ */jsx(RadioSwatchGroup_MoreButton_default, {}),
      className
    } = _b,
    rest = __objRest(_b, ["children", "maxItems", "moreButton", "className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent, __spreadProps(__spreadValues({
    direction: "horizontal",
    maxItems,
    moreButton,
    className: clsx("pd:radio-swatch-group", className)
  }, rest), {
    children: /* @__PURE__ */jsx(CheckableGroupComponent.Fields, {
      children
    })
  }));
};
var RadioSwatchGroup_default = RadioSwatchGroup;
export { RadioSwatchGroup_default };